import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M20 10h-16l5.5 -6","key":"svg-0"}],["path",{"d":"M4 14h16l-5.5 6","key":"svg-1"}]]

const IconTransfer = createReactComponent('outline', 'transfer', 'Transfer', __iconNode);

export default IconTransfer;